import React, { AllHTMLAttributes } from 'react';
import { FormattedHTMLMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { setRef, getSafe } from '@sheerid/jslib';

export type InputTextAreaProps = {
    id: string;
    isErrored: boolean;
    className?: string;
    hidePlaceholder?: boolean;
    onChange?: React.ChangeEventHandler;
    onKeyDown?: React.ChangeEventHandler;
    ref?: never;
    refId?: string;
    required?: boolean;
    type?:'text' | 'email' | 'password' | 'search' | 'url' | 'tel';
    rows:number;
    cols:number;
    maxLength:number,
    placeholder:string,
    value:string,
}
& AllHTMLAttributes<HTMLTextAreaElement>
& InjectedIntlProps;

const InputTextArea = ({
    id,
    isErrored,
    className = undefined,
    hidePlaceholder = true,
    refId,
    required = false,
    type = 'text',
    intl,
    value,
    onChange,
    ...props
}: InputTextAreaProps) => {
    let internalClassName = '';
    if (className) internalClassName += `${className} `;
    internalClassName += 'sid-text-area-input sid-l-full-width';
    if (hidePlaceholder) internalClassName += ' sid-hidden-placeholder';
    if (required) internalClassName += ' sid-text-area-input--required';
    if (isErrored) internalClassName += ' sid-text-area-input--error';

    const finalRefId = refId ? refId : id;

    const [fieldCharacterCount, updateFieldCharacterCount] = React.useState(0);
    const [showCharCount, setShowCharCount] = React.useState(false);

    const handleOnBlur = () => {
        if (value || value.length <= 0) {
            setShowCharCount(false);
        } else  {
            setShowCharCount(true);
        }
    };

    return (
        <div>
            <textarea
                className={internalClassName}
                id={`sid-${id}`}
                name={`sid-${id}`}
                ref={(input => setRef(finalRefId, input))}
                aria-required={required}
                onBlur={handleOnBlur}
                onFocus={() => setShowCharCount(true)}
                onChange={(e: any) => {
                    onChange(e.target.value)
                    updateFieldCharacterCount(getSafe(() => e.target.value.length, 0))
                }}
                {...props}
            />

            { 
                showCharCount ?
                    <div className='sid-project-description-char-counter'>
                        <FormattedHTMLMessage
                            id="step.personalInfo.projectDescriptionCounter"
                            defaultMessage="Character Count: {count}/256"
                            values={{ count: fieldCharacterCount }}
                        />
                    </div>
                : null
            }

        </div>
    );
};

export const InputTextAreaComponent = injectIntl(InputTextArea);
